import * as React from 'react';
import { css } from '@emotion/core';
import { RaterApprovalRater } from './models';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { faCircle as faCircleSolid, faCheck } from '@fortawesome/free-solid-svg-icons';
import { COLORS } from '../globalStyle/colors';
import ActionIcon from '../layout/ActionIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FLEX_COLUMN } from '../layout/flexBox';
import { lastCommaFirstLocal } from '../project/survey/raters/module';
import { TextDirection } from '../localization/textDirection';
import Spacer from '../layout/Spacer';
import LocalDiv from '../localization/LocalDiv';
import { useMsgText } from '../localization/hooks';
import { Str } from '../localization/translationKeys';


const styles = {
  nameEmailCell: FLEX_COLUMN,
  greenIcon:     css`
    font-size: 18px;
    height: 1em;
    vertical-align: 0;
    color: ${COLORS.GREEN};
  `,
  grayIcon:      css`
    font-size: 18px;
    height: 1em;
    vertical-align: 0;
    color: ${COLORS.DARK_GREY};
  `,
};


type Props = {
  className?: string;
  rater: RaterApprovalRater;
  textDirection: TextDirection;

  showName: boolean;
  approved: boolean;
  declined: boolean;
  canEdit: boolean;

  markRaterApproved: () => void;
  markRaterDeclined: () => void;
};


/**
 * RaterApprovalTableRow: a component that presents information about a yet-to-be-approved project rater, as a table row
 *
 * PureComponent: true
 * Redux Connected: false
 */
const RaterApprovalTableRow: React.FC<Props> = props => {
  const approveLabel = useMsgText(Str.Approve);
  const declineLabel = useMsgText(Str.Decline);

  const onClickApproveIcon = (event: React.MouseEvent) => {
    event.preventDefault();
    props.markRaterApproved();
  };

  const onClickDeclineIcon = (event: React.MouseEvent) => {
    event.preventDefault();
    props.markRaterDeclined();
  };

  return (
    <tr css={props.className}>
      <td>
        <LocalDiv css={styles.nameEmailCell}>
          {
            props.showName && (
              <>
              <span>
                {lastCommaFirstLocal(props.textDirection, props.rater)}
              </span>
                <Spacer sizePx={4} />
              </>
            )
          }
          <span>{props.rater.email}</span>
        </LocalDiv>
      </td>
      <td>
        {props.rater.levelName}
      </td>
      <td>
        {
          props.canEdit
            ? (
              <ActionIcon
                icon={props.approved ? faCircleSolid : faCircle}
                iconStyle={props.approved ? styles.greenIcon : styles.grayIcon}
                onClick={onClickApproveIcon}
                aria-label={approveLabel}
              />
            ) : (
              props.approved
                ? (
                  <FontAwesomeIcon icon={faCheck} css={styles.greenIcon} />
                ) : null
            )
        }
      </td>
      <td>
        {
          props.canEdit
            ? (
              <ActionIcon
                icon={props.declined ? faCircleSolid : faCircle}
                iconStyle={styles.grayIcon}
                onClick={onClickDeclineIcon}
                aria-label={declineLabel}
              />
            ) : (
              props.declined
                ? (
                  <FontAwesomeIcon icon={faCheck} css={styles.grayIcon} />
                ) : null
            )
        }
      </td>
    </tr>
  );
};

export default RaterApprovalTableRow;
